type InboxMessageLike = { read?: boolean | null; direction?: string | null };

/**
 * Received plan mail not yet read. get-messages labels sent mail 'outgoing'
 * (older payloads said 'outbound') and stores it unread, so both are left out.
 */
export function unreadInboxCount(messages: InboxMessageLike[] | null | undefined): number {
  if (!Array.isArray(messages)) return 0;
  return messages.filter((m) => !m.read && m.direction !== 'outgoing' && m.direction !== 'outbound').length;
}
